{
  "errors": {
    "bundle_initial_fetch_error": "Fetching bundle or bundle related data failed",
    "dependency_data_error": "The system doesn't seem to have any locales. Bundles can be added only after there is at least one locale in the system",
    "adding_variant_error": "Adding variant to bundle failed"
  },
  "editscreen": {
    "add_bundle_title": "Add New Bundle",
    "update_bundle_title": "Update Bundle",
    "buttons": {
      "save_changes": "Save changes"
    },
    "confirm_unsaved_changes": "You have unsaved changes. Are you sure you want to leave the form?",
    "translation": "Translation",
    "reference": "Reference",
    "reference_english": "English",
    "sections": "Sections",
    "section_has_errors_tooltip": "This section has errors. Fix them before saving changes.",
    "section_titles": {
      "name": "Bundle name",
      "product_variants": "Bundle products",
      "description": "Bundle description",
      "images": "Images"
    },
    "errors": {
      "name_blank": "Name must not be blank",
      "finance_id_blank": "Finance id must not be blank",
      "no_main_item_variants": "Main item of bundle must have at least one variant",
      "addon_item_name_blank": "Product group name must not be blank",
      "no_addon_item_variants": "Product group must have at least one product variant",
      "description_blank": "Description must not be blank",
      "description_translation_blank": "Translation ({{languages}}) for description must not be blank",
      "validation": "Some sections contain invalid data. Fix these before saving changes.",
      "create_bundle": "Error occurred while creating bundle",
      "update_bundle": "Error occurred while updating bundle"
    }
  },
  "name_section": {
    "info": "Product bundle name and finance ID.",
    "name_reference_label": "Bundle name reference",
    "name_reference_placeholder": "Bundle name reference",
    "name_translation_label": "Bundle name translation",
    "name_translation_placeholder": "{{language}} translation",
    "finance_id_label": "Telia finance ID",
    "finance_id_placeholder": "Finance id"
  },
  "product_variants_section": {
    "main_product_title": "Main product",
    "main_product_info": "Select main product and included variants.",
    "addons_title": "Addons",
    "addons_info": "Add, edit or remove addon products from the bundle.",
    "main": {
      "view_product": "View product",
      "add_variants": "Add variants",
      "search_select_product_label": "Select product",
      "search_placeholder": "Search..",
      "search_disable_already_variants": "Bundle main item already has variants. All variants part of bundle's main item need to be from same product.",
      "choose_variants_info": "This product has variants. Select one or more:",
      "variants_search_placeholder": "Search variants...",
      "duplicate_product_variant": "This product variant is already part of this bundle",
      "select_product_variants_btn": "Select product variants",
      "add_variants_no_variants_selected_title": "You must select at least one product variant",
      "cancel_selecting_product_variants": "Cancel",
      "selected_product_variants_count_one": "Selected {{count}} product",
      "selected_product_variants_count_other": "Selected {{count}} products",
      "cant_remove_all_products_tooltip": "Can't remove all products from bundle. At least one product needs to be left.",
      "product_variant_name_table_header": "Product name",
      "product_variant_sku_table_header": "SKU",
      "search_products_error": "Error happened when searching for products",
      "fetch_product_variants_error": "Error happened when adding a product",
      "buttons": {
        "remove_product_variants": "Remove"
      }
    },
    "addons": {
      "view_product": "View product",
      "rename_product_group": "Rename",
      "add_product_variants_to_product_group": "Add product variants",
      "add_product_group": "Add product group",
      "add_product_group_title": "Add product group",
      "update_product_group_title": "Update product group",
      "add_products_to_product_group_info": " Add one or more products. If the group has more than one product, buyer has to pick one.",
      "product_group_name_reference_label": "Group name reference",
      "product_group_name_reference_placeholder": "Group name reference",
      "product_group_name_translation_label": "Group name translation",
      "product_group_name_translation_placeholder": "{{language}} translation",
      "search_select_product_label": "Select product",
      "search_placeholder": "Search..",
      "choose_variants_info": "This product has variants. Select one or more:",
      "variants_search_placeholder": "Search variants...",
      "duplicate_product_variant": "This product variant is already part of this bundle",
      "add_product_group_btn": "Add product group",
      "update_product_group_btn": "Update product group",
      "add_variants_to_product_group_no_variants_title": "Product group must have at least one product variant",
      "set_product_group_name_name_empty_title": "Product group must have a reference name",
      "cancel_btn": "Cancel",
      "selected_product_variants_count_one": "Selected {{count}} product",
      "selected_product_variants_count_other": "Selected {{count}} products",
      "product_variant_name_table_header": "Product name",
      "product_variant_sku_table_header": "SKU",
      "product_variants_in_group_count_one": "{{count}} product variant",
      "product_variants_in_group_count_other": "{{count}} product variants",
      "search_products_error": "Error happened when searching for products",
      "fetch_product_variants_error": "Error happened when adding a product",
      "remove_product_variants_confirmation": {
        "close": "Cancel",
        "remove": "Remove",
        "title": "Remove product variants",
        "info": "You are about to remove all the product variants from at least one product group. This will also delete the product group itself. Are you sure you want to remove the selected variants?"
      },
      "buttons": {
        "remove_product_variants": "Remove"
      }
    },
    "tf_automatic_pricing_errors": {
      "tfap_missing_title": "TFAP missing",
      "tfid_missing_title": "Telia Finance product name missing",
      "tfap_or_tfid_missing_message_start": "Use",
      "tfap_or_tfid_missing_link": "the product page",
      "tfap_missing_message_end": "to add the default acquisition price (TFAP) to this product for these countrie(s): {{countries}}.",
      "tfid_missing_message_end": "to add the Finance product name to this product for these countrie(s): {{countries}}.",
      "hidden_from_sales_channels_title": "Bundle will be hidden from some sales channels",
      "hidden_from_sales_channels_text_1": "This bundle has products with missing information (see above).",
      "hidden_from_sales_channels_text_2": "Sales channels with automatic pricing can’t sell it. It will be hidden from:",
      "hidden_from_sales_channels_text_3": "To fix this, fill in the missing information on the product page(s)."
    }
  },
  "description_section": {
    "info": "Bundle description is the main copytext of the bundle.",
    "description_reference_label": "Description reference",
    "description_reference_placeholder": "Description reference",
    "description_translation_label": "Description translation",
    "description_translation_placeholder": "{{language}} translation"
  },
  "images_section": {
    "info": "Upload bundle images.",
    "bundle_image_alt": "Bundle image",
    "image_name_placeholder": "Bundle image",
    "buttons": {
      "upload_image": "Upload file"
    },
    "delete_image": "Delete image"
  }
}
